import config from '@/config'

const translations = config.LOCALIZATION_DATA

const t = (string) => translations[`kainos.Web.Constants.Resources.${string}`] || string

/* eslint-disable */
export {
  t
}
/* eslint-disable */